import type { AuthenticationV1Account } from '@sdk/Api'

export enum UserRole {
	Admin = 'Admin',
	Affiliate = 'Affiliate',
	AffiliateManager = 'Affiliate Manager',
	SuperAffiliateManager = 'Super Affiliate Manager',
	Advertiser = 'Advertiser',
}

export function isRole(role: UserRole, account: AuthenticationV1Account): boolean {
	return account?.role?.name === role
}
